module.exports = __webpack_public_path__ + "img/link-duo.3899ba3a.png";